<template>
  <div class="input" v-if="items.length > 0">
    <label>{{label}}</label>
    <select :required="required" :disabled="disabled" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" @change="h => $emit('change', h)">
      <option v-if="!noNone" :value="undefined">{{none || "None"}}</option>
      <option v-for="(item, i) in items" :key="i" :value="val(item)">
        {{display(item)}}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: ["label", "itemText", "itemValue", "items", "value", "none", "disabled", "required", "noNone"],
  methods: {
    val(item) {
      if (this.itemValue) {
        return item[this.itemValue];
      }
      return item;
    },
    display(item) {
      if (this.itemText) {
        return item[this.itemText];
      }
      return item;
    }
  }
}
</script>

<style>

</style>
